import * as makerjs from 'makerjs';


function WindowGrid(
    doorType, width, height, rows = 1, columns = 4, spacing, fillet,
    outerFrame, outerFrameWidth, w1, w2, w3, w4, innerMargin, overallHeight = 0.5
) {
    var sizes = {};
        sizes[`overallHeight`] = overallHeight;
        sizes[`doorType`] = doorType;
    var columnWidths = [w1, w2, w3, w4];
    
    var totalWidth = columnWidths.reduce((sum, current) => sum + current, 0) + (columns - 1) * spacing;
    var cellModels = [];
    var xOffset = -width / 2;
    var innerRectModels = {};

    for (var i = 0; i < columns; i++) {
        var columnWidth = columnWidths[i];
        var columnHeight = (height -  overallHeight - (rows - 1) * spacing) / rows;
        sizes[`r${i + 1}`] = {
            width: columnWidth,
            height: columnHeight,
            x: xOffset, // x-coordinate from origin
            y: 0        // y-coordinate for the row (always 0 here)
        };

        var cell = new makerjs.models.RoundRectangle(columnWidth, columnHeight, fillet);
        cell.origin = [xOffset, 0];
        xOffset += columnWidth + spacing;
        
        // Add inner rectangles for w2 and w3
        if (i === 1 || i === 2) {
            var innerWidth = columnWidth - 2 * innerMargin;
            var innerHeight = columnHeight - 2 * innerMargin;
            var innerRect = new makerjs.models.RoundRectangle(innerWidth, innerHeight, fillet);

            let yOffsetAdjustment = innerMargin / 2 + spacing * 2 + 4;
            if ((columns == 4) || ((columns == 3) && (i === 1))) {
                innerRect.origin = [
                    xOffset - columnWidth + innerMargin - 2,
                    -columnHeight / 2 + innerMargin + innerHeight / 2 + yOffsetAdjustment
                ];
                sizes[`R${i}`] = {
                    width: columnWidth,
                    height: columnHeight,
                    x: xOffset, 
                    y: 0    
                };
                sizes[`innerRect${i}`] = {
                    width: innerWidth,
                    height: innerHeight,
                    x: innerRect.origin[0], // x-coordinate from innerRect origin
                    y: innerRect.origin[1]  // y-coordinate from innerRect origin    
                };
                innerRectModels["innerRect" + i] = innerRect;
            }

            
        }

        cellModels.push(cell);
    }

    var grid = { models: {} };
    
    cellModels.forEach((cell, i) => grid.models["cell" + i] = cell);
    Object.keys(innerRectModels).forEach((key) => grid.models[key] = innerRectModels[key]);

    if (Object.keys(grid.models).length === 0) {
        console.error('Grid models are empty, cannot center grid.');
        return;
    }

    makerjs.model.center(grid);
    grid.origin = [0, -height / 2];

    this.models = { grid };

    if (outerFrame) {
        var adjustHorizontalPosition = -6;
        var frameWidth = width + 2 * outerFrameWidth;
        var frameHeight = height + 2 * outerFrameWidth + 8;
        var frame = new makerjs.models.Rectangle(frameWidth, frameHeight);
        frame.origin = [adjustHorizontalPosition -frameWidth / 2, -frameHeight / 2];
        this.models.frame = frame;
    }
    //sizes['aaa'] = {width: 22, height: 33}
    // Override toSVG to apply colors
    this.toSVG = function () {
        let svg = makerjs.exporter.toSVG(this);
        return svg;
    };
    return { svg: this.toSVG(), sizes: sizes };
}

export default WindowGrid;
